<style lang="scss" scoped>
    @media screen and (max-width: 767px) {
        .table_payments > .table > {
            thead,
            tbody,
            tfoot {
                > tr > {
                    th:first-child, 
                    td:first-child {
                        white-space: pre-line;
                    }
                }
            }
        }
    }
</style>

<template>
    <div class="table-responsive table_payments" v-if="payments.length > 0">
        <table class="table m-0 table-hover">
            <tbody>
                <template v-for="(item, index) in payments" v-if="!record.quote_payment_id ? true : (record.quote_payment_id == item.id ? true : false) ">
                    <tr>
                        <td class="t_center" colspan="5">
                            <strong>{{ $t('payment_package') }} {{ index+1 }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <th class="t_center">{{ $t('payment_method') }}</th>
                        <th class="t_center">{{ $t('installments') }}</th>
                        <th class="t_center">{{ $t('fee') }}</th>
                        <th class="t_center">{{ $t('installment_value') }}</th>
                        <th class="t_center">{{ $t('value') }}</th>
                    </tr>
                    <tr v-for="payment in item.items">
                        <td class="t_center">{{ payment.payment_method.display_name }}</td>
                        <td class="t_center">{{ payment.installments }}</td>
                        <td class="t_center">
                            {{ (payment.value + ((payment.fee/100) * payment.value)) - payment.value | pmlCurrency(currency.symbol) }} ({{ payment.fee }}%)
                        </td>
                        <td class="t_center">
                            {{ (payment.value + ((payment.fee/100) * payment.value)) / payment.installments | pmlCurrency(currency.symbol) }}
                        </td>
                        <td class="t_center">
                            {{ payment.value + ((payment.fee/100) * payment.value) | pmlCurrency(currency.symbol) }}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4" class="t_right"><strong>{{ $t('total') }}</strong></td>
                        <td class="t_center">{{ calculateTotal(item.items) | pmlCurrency(currency.symbol) }}</td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        name: 'Products',
        props: [ 'record', 'payments', 'currency' ],
        methods: {
            calculateTotal (items) {
                return items.reduce((sum, payment) => {
                    return sum + payment.value + ((payment.fee / 100) * payment.value)
                }, 0)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/my-quotation/components/PaymentPackages.vue